import React from 'react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { observer } from 'mobx-react';
import LoggedInButton from './LoggedInButton';
import LoggedOffButton from './LoggedOffButton';

type Props = {
    focus?: boolean
};

const ButtonFactory: React.FC<Props> = observer(({ focus }) => (UserStore.isLoggedIn
  ? <LoggedInButton focus={focus} />
  : <LoggedOffButton focus={focus} />));

export default ButtonFactory;
